import { connect } from "react-redux";
import ComparisonView from "./ComparisonView";
import { getProjectComparison } from "../../../../../../../../redux/actions";

// The filters the fetch is built from, plus a single initial-load flag for the
// shared loader — isProcessing would catch search reloads too and tear the
// section down mid-typing. Deliberately a boolean, not the api objects: those
// change on every infinite-scroll page, which would re-render this whole view.
// Each table reads its own rows.
const mapStateToProps = (state) => {
    const { benchmarkFiltersAnalysis, fetchProjectComparisonApi, fetchProjectNotComparedApi } = state.BenchmarkFilteringReducer;
    return {
        benchmarkFiltersAnalysis,
        isInitialLoading: !!((fetchProjectComparisonApi && fetchProjectComparisonApi.isInitialLoading)
            || (fetchProjectNotComparedApi && fetchProjectNotComparedApi.isInitialLoading)),
        // The search the rows in the store were fetched under — '' unless a
        // search narrowed them. Both lists are always fetched together, so one
        // of them answers for both.
        cachedSearchText: (fetchProjectComparisonApi && fetchProjectComparisonApi.searchText) || '',
        // Lists the applied filters leave with nobody in them. Booleans rather
        // than the totals themselves, so a changing count can't re-render the
        // view. null (not reported yet) is not empty — only a stated 0 is.
        isComparedEmpty: !!fetchProjectComparisonApi && fetchProjectComparisonApi.baseListTotal === 0,
        isNotComparedEmpty: !!fetchProjectNotComparedApi && fetchProjectNotComparedApi.baseListTotal === 0,
    };
};

const mapDispatchToProps = (dispatch) => ({
    getProjectComparison: (payload) => dispatch(getProjectComparison(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ComparisonView);
